<template>
  <div>
    <v-flex>
      <section>
        <v-card
          flat>
          <v-tabs
            v-model="selected.menu"
            background-color="transparent"
            color="#ff64ad"
            slider-size="5"
            show-arrows
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            dense
            grow
            class="d-flex justify-start tabs-stream">
            <v-tab
              v-for="(item, index) in list.menu"
              :key="index"
              class="px-0 mr-4 d-flex align-center">
              <v-avatar
                tile
                size="20">
                <v-img 
                  contain
                  :src="item.icon">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        size="20"
                        color="#ff64ad">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>

              <span 
                class="body-2 text-capitalize ml-2" 
                :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                {{ item.text }}
              </span>
            </v-tab>
          </v-tabs>

          <v-card-text
            class="pa-0">
            <div v-if="selected.menu < 1">
              <Role />
            </div>

            <div v-else>
              <Account />
            </div>
          </v-card-text>
        </v-card>
      </section>
    </v-flex>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        list: {
          menu: [
            {
              text: 'Role',
              value: 'role',
              icon: require('@/assets/image/user/role.png')
            },
            {
              text: 'Admin',
              value: 'admin',
              icon: require('@/assets/image/user/admin.png')
            }
          ]
        }
      }
    },
    components: {
      Role: () => import(/* webpackPrefetch: true */ '@/components/admin/role.vue'),
      Account: () => import(/* webpackPrefetch: true */ '@/components/admin/account.vue'),
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      this.selected.menu = this.$route.query.type === undefined ? 0 : this.$route.query.type === 'operator' ? 1 : 0
    },
    methods: {
      
    }
  }
</script>